import styles from "./ActionMenuButtonsRow.module.scss";
import React from "react";

const ActionMenuButtonsRow = ({children, dataTestId = 'action-menu-buttons-row'}) => {
    return <div className={styles.base} data-testid={dataTestId}>
        {children}
    </div>
}

export default ActionMenuButtonsRow;
